<template>
  <a-layout>
    <a-layout-content>
      <cui-sidebar v-if="mode != 'production' && false" />
      <div
        :class="{
          [$style.container]: true,
          cui__layout__squaredBorders: settings.isSquaredBorders,
          cui__layout__cardsShadow: settings.isCardShadow,
          cui__layout__borderless: settings.isBorderless,
          [$style.white]: settings.authPagesColor === 'white',
          [$style.gray]: settings.authPagesColor === 'gray',
        }"
        :style="{
          backgroundImage:
            settings.authPagesColor === 'image'
              ? `url(resources/images/content/photos/7.jpg)`
              : 'none',
        }"
      >
        <!-- <div
          :class="{
            [$style.topbar]: true,
            [$style.topbarGray]: settings.isGrayTopbar,
          }"
        >
          <div :class="$style.logoContainer">
            <div :class="$style.name">
              SCG Debenture Club
            </div>
          </div>
        </div> -->
        <div :class="$style.containerInner">
          <transition :name="settings.routerAnimation" mode="out-in">
            <router-view />
          </transition>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script>
import { mapState } from 'vuex';
import CuiSidebar from '@/components/cleanui/layout/Sidebar';
export default {
  name: 'AuthLayout',
  components: { CuiSidebar },
  computed: mapState(['settings']),
  data: function () {
    return {
      mode: process.env.NODE_ENV,
    };
  },
};
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
